import { ContextMenu as CContextMenu } from '@consta/uikit/ContextMenu';
import { useRef, useState } from 'react';
import styles from './styles.module.css';

export const Burger = ({
  items = [{ value: 'test', label: 'Текст' }],
  className = '',
  buttonClassName = '',
  onItemSelect = () => undefined,
  disabled = false,
}: {
  items: Array<{ value: string; label: string }>;
  onItemSelect: (item: { value: string; label: string }) => void;
  className?: string;
  buttonClassName?: string;
  disabled?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = useRef(null);

  return (
    <>
      <button
        className={`${styles.burger} ${buttonClassName}`}
        data-disabled={disabled}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        ref={ref}
      >
        <svg
          width="4"
          height="16"
          viewBox="0 0 4 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2" cy="14" r="2" transform="rotate(-180 2 14)" fill="#7E89A5" />
          <circle cx="2" cy="8" r="2" transform="rotate(-180 2 8)" fill="#7E89A5" />
          <circle cx="2" cy="2" r="2" transform="rotate(-180 2 2)" fill="#7E89A5" />
        </svg>
      </button>
      <CContextMenu
        className={`${styles.context} ${className}`}
        isOpen={isOpen}
        items={items}
        getItemLabel={(item) => item.label}
        anchorRef={ref}
        offset={16}
        direction="leftCenter"
        onItemClick={({ item }) => {
          onItemSelect(item);
          setIsOpen(false);
        }}
        onClickOutside={() => setIsOpen(false)}
      />
    </>
  );
};
